<template>
  <div
    class="is-border vadTask"
    :class="{'is-grey has-text-grey': hasChanged, 'has-background-white': !hasChanged}">
    <div class="vadTask-hover"></div>
    <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
      <div class="columns">
        <div class="column is-narrow">
          <avatar
            :use-picto-custom="'fal fa-lg fa-building'"
            :force-picto="true"
            :is-avatar="false"
            :item="{}"
            class="has-background-success is-medium has-text-white is-margin-top-xsmall">
          </avatar>
        </div>
        <div class="column">
          <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xxsmall">
            <span v-if="isToday">Aujourd’hui à {{ option.start_date | dtFormat('HH[h]mm') }}</span>
            <span v-else>{{ option.start_date | prettyDatetime }}</span>
          </p>
          <p class="is-size-4 is-margin-bottom-xsmall">
            <strong>Option —
              <router-link
                v-if="'lot' in option"
                :to="{name: 'LotVue', params: {id: option.lot.pk}}">
                {{ option.lot.ref }}
              </router-link>
              <router-link
                v-if="option.program && option.program.pk"
                :to="{name: 'ProgramVue', params: {id: option.program.pk}}">
                <span class="is-size-4">— {{ option.program.name }}</span>
              </router-link>
            </strong>
          </p>
          <div class="columns is-multiline is-gapless is-margin-bottom-xxsmall">
            <div
              v-if="option.program && option.program.pk"
              class="column is-narrow">
              <router-link
                :to="{name: 'ProgramVue', params: {id: option.program.pk}}"
                class="is-size-6">
                <span class="has-text-grey">Programme :</span><br><span
                  class="is-hover-underline">{{ option.program.name }}</span>
              </router-link>
            </div>
          </div>
          <div class="columns is-multiline">
            <div
              v-if="option.account.pk === option.promoteur.pk"
              class="column is-narrow">
              <router-link
                v-if="'user' in option"
                :to="{name: 'UserVue', params: {id: option.user.pk}}"
                class="is-size-6">
                <span class="has-text-grey">Vendeur :</span><br><span
                  class="is-hover-underline">{{ option.user.first_name }} {{ option.user.last_name }}</span>
              </router-link>
            </div>
            <div
              v-if="option.account.pk !== option.promoteur.pk"
              class="column is-narrow">
              <span class="has-text-grey is-size-6">Société :</span><br>
              <router-link
                v-if="'account' in option"
                :to="{name: 'CompanyVue', params: {id: option.account.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ option.account.name }}</span>
              </router-link>
            </div>
            <div class="column is-narrow">
              <span class="has-text-grey is-size-6">Contact :</span><br>
              <router-link
                v-if="'contact' in option && option.contact.account.pk === currentUser.account.pk"
                :to="{name: 'ContactVue', params: {id: option.contact.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ option.contact.first_name }} {{ option.contact.last_name }}</span>
              </router-link>
              <span
                v-else-if="'contact' in option"
                class="is-size-6">{{ option.contact.first_name }} {{ option.contact.last_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="option_doublon && option_doublon.duplicates && option_doublon.duplicates.length > 0 || option_doublon && option_doublon.all_pk_contact && option_doublon.all_pk_contact.length > 0"
      class="has-background-danger">
      <div class="has-text-white margin-left  is-size-7 is-padding-top-xsmall is-padding-bottom-xsmall">
        <i>DONNÉES SIMILAIRES DÉTECTÉES SUR : </i>
        <router-link :to="{ name: 'DenunciationList', params: { filter: claim_list_pk, status: ['approved', 'pending'], resetFiltersForDoublon: true }}">
          <a
            v-if="option_doublon.duplicate_risk"
            class="is-size-7 has-text-white is-padding-right-xsmall">
            <span> BASE DÉNONCIATION </span>
            <a class="hover-text">
              <span class="is-size-7 has-text-white">(<a class="is-size-7 has-text-white">{{ option_doublon.duplicate_risk || 0 }}/3 </a><i class="fas fa-info-circle"></i>)</span>
              <span
                class="tooltip-text"
                id="top">{{ messages[option_doublon.duplicate_risk - 1] }}</span>
            </a>
          </a>
        </router-link>
        <router-link :to="{ name: 'ContactList', params: { filter: option_doublon.all_pk_contact, resetFiltersForDoublon: true }}">
          <a
            v-if="option_doublon.all_pk_contact"
            class="is-size-7 has-text-white">
            <span> BASE CONTACT </span>
            <a class="hover-text">
              <span class="is-size-7 has-text-white">(<a class="is-size-7 has-text-white">{{ option_doublon.all_pk_contact_risk || 0 }}/3 </a><i class="fas fa-info-circle"></i>)</span>
              <span
                class="tooltip-text"
                id="top">{{ messages_2[option_doublon.all_pk_contact_risk - 1] }}</span>
            </a>
          </a>
        </router-link>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in">
      <div
        v-if="hasChanged"
        key="noButtons"
        class="veryFastAnimation is-padding-top-xsmall is-padding-bottom-xsmall is-border-top vadTask-footer has-background-light--darken1 is-border-top is-border--dashed">
        <div class="">
          <span class="has-text-grey is-size-6">Option Supprimée</span>
        </div>
      </div>
      <div
        v-else
        key="buttons"
        class="veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border--dashed vadTask-footer columns is-gapless">
        <div class="column is-4-desktop-only is-narrow-widescreen">
          <button
            v-if="canDeleteOption"
            @click="deleteOption()"
            class="button is-white is-small is-size-7 is-fullwidth"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-stop-circle"></i></span>
            <span>Annuler option</span>
          </button>
        </div>
        <div class="column is-4-desktop-only is-narrow-widescreen">
          <router-link
            v-if="'lot' in option"
            class="button is-white is-small is-size-7 is-fullwidth"
            :to="{name: 'LotVue', params: {id: option.lot.pk}}">
            <span class="icon is-small"><i class="fas fa-arrow-right"></i></span>
            <span>Fiche détaillée du lot</span>
          </router-link>
        </div>
        <div class="column is-narrow-widescreen">
          <button
            @click="checkDuplicate"
            v-if="isPromoteur"
            class="button is-white is-small is-size-7 is-fullwidth"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-id-card-alt"></i></span>
            <span>Vérifier</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { Option } from '@/mixins'

export default {
  name: 'OptionCard',
  mixins: [Option],
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      initialStatus: null,
      cardLoading: false,
      messages: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
      messages_2: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
      option_doublon: {},
      claim_list_pk: []
    }
  },
  computed: {
    ...mapGetters(['currentUserPk', 'isAdmin']),
    hasChanged () {
      return this.option.status !== this.initialStatus
    },
    /**
     * return option start date
     * @return {date}
     */
    date () {
      return moment(this.option.start_date)
    },
    /**
     * is today
     * @return {boolean}
     */
    isToday () {
      return this.date.isSame(moment(), 'day')
    },
    /**
     * status is wating_list or approved
     * @return {boolean}
     */
    isRunning () {
      return this.status === 'waiting_list' || this.status === 'approved'
    },
    /**
     * status is canceled
     * @return {boolean}
     */
    isCanceled () {
      return this.status === 'canceled'
    },
    /**
     * option status
     * @return {string}
     */
    status () {
      return this.option.status
    },
    /**
     * can delete option
     * @return {boolean}
     */
    canDeleteOption () {
      return this.canUpgrade(this.option.status) && (this.isAdmin || this.option.user.pk === this.currentUser.pk || this.isInUserTeam(this.option.user.pk))
    }
  },
  created () {
    this.initialStatus = this.option.status
  },
  methods: {
    async getClaimContact () {
      if (this.option_doublon && this.option_doublon.duplicates.length > 0) {
        for (let i of this.option_doublon.duplicates) {
          let params = {
            status: ['approved', 'pending'],
            contact: i.pk
          }
          let { data } = await this.$api.get(this.$resources.CLAIM, params)
          data.items.forEach(claim => { this.claim_list_pk.push(claim.pk) })
        }
      }
    },
    /**
     * delete option
     * call confirm delete
     * then call update option with pk, status, and text
     */
    deleteOption () {
      this.confirmDelete().then(r => {
        if (r.value) {
          this.updateOption(this.option.pk, { status: 'canceled' }, 'L\'option a été annulée.')
        }
      })
    },
    async checkDuplicate () {
      this.cardLoading = true
      try {
        let payload = {
          contact: this.$cleanPayload(this.option.contact),
          user: this.option.user.pk
        }
        let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
        this.cardLoading = false
        if (data.duplicates.length > 0 || data.all_pk_contact.length > 0) {
          this.option_doublon.duplicates = data.duplicates
          this.option_doublon.duplicate_risk = data.duplicate_risk
          this.option_doublon.all_pk_contact = data.all_pk_contact
          this.option_doublon.all_pk_contact_risk = data.all_pk_contact_risk
          if (this.option_doublon.all_pk_contact.length > 0) {
            this.option_doublon.all_pk_contact.push(this.option.contact.pk)
          }
          await this.getClaimContact()
          this.$toasted.global.danger('Doublon trouvé')
        } else {
          this.option_doublon.duplicates = null
          this.option_doublon.duplicate_risk = null
          this.option_doublon.all_pk_contact = null
          this.option_doublon.all_pk_contact_risk = null
          this.option_doublon.claim_list_pk = null
          this.$toasted.global.success('Aucun doublon trouvé')
        }
      } catch (e) {
        this.cardLoading = false
        console.log(e)
      }
    },
    showDuplicates (option) {
      if (option.duplicate_risk === 1) {
        this.$router.push({ name: 'DenunciationList', query: { contact__searchable_name: `${option.contact.first_name} ${option.contact.last_name}`, status: ['approved', 'pending'] } })
      }
      if (option.duplicate_risk === 2) {
        this.$router.push({ name: 'DenunciationList', query: { contact__email: option.contact.email, status: ['approved', 'pending'] } })
      }
      if (option.duplicate_risk === 3) {
        this.$router.push({ name: 'DenunciationList', query: { contact__email: option.contact.email, status: ['approved', 'pending'] } })
      }
    }
  }
}
</script>
<style>
.margin-left {
  margin-left: 7.5rem;
}

.tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  width: 100px;
  color: white;
  font-size: 12px;
  background-color:  #474849;
  border-radius: 10px;
  opacity: 0.80;
  padding: 5px 10px 5px 10px;
}

.hover-text:hover .tooltip-text {
  visibility: visible;
}

#top {
  top: -8px;
  left: 105%;
}

.hover-text {
  position: relative;
  display: inline-block;
  font-family: Roboto;
}

</style>
